// generate ExerciseCategoriesTable component like AppFileTable but use ExerciseCategory model
import Container from "../../../../components/container";
import { ExerciseCategory, ExerciseLoadType } from "../../../../models";
import { UpdateButton, DeleteButton } from "./buttons";

export default function ExerciseLoadTypesTable({
  items,
}: {
  items: ExerciseLoadType[];
}) {
  return (
    <Container className="max-w-xl  text-left">
      <table className="min-w-full text-gray-900 text-left ">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th scope="col" className="px-6 py-3">
              Name
            </th>

            <th scope="col" className="px-6 py-3">
              <span className="sr-only">Edit</span>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {items.map((item) => (
            <tr key={item.id}>
              <td className="whitespace-nowrap px-6 py-3">{item.name}</td>

              <td className="px-6 py-4">
                {item.id ? (
                  <div className="flex flex-1 items-center justify-end gap-2">
                    <UpdateButton id={item.id} />
                    <DeleteButton id={item.id} />
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}
